import React, { Component } from 'react';
import '../App.css';
import myHebcal from '../Codes/myHebcal';

//var repeat=['ללא','יומית','שבועית','חודשית','שנתית'];
class RepeatCheckBox extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      whatIsChecked: 0, //0-no repeat, 1-to year in input, 2-forever
      repeat_year_chosen: 1,
      to_year: 2
    };
    this.radioClick = this.radioClick.bind(this);
  }
  
  onInputUpdate(event){
    let year=parseInt(event.target.value);
    this.setState({to_year: year, repeat_year_chosen: year});
    this.props.setToYear(year);
  }

  radioClick(event){
    if(event.target.id==="radio-none")
    {
      this.setState({whatIsChecked: 0, repeat_year_chosen: 1});
      this.props.setToYear(1);
    }
    if(event.target.id==="radio-year")
    {
      this.setState({whatIsChecked: 1, repeat_year_chosen: this.state.to_year});
      this.props.setToYear(this.state.to_year);

    } 
    /*if(event.target.id==="radio-forever")
    {
      this.setState({whatIsChecked: 2, repeat_year_chosen: 'התתר'});
      this.props.setToYear('התתר');

      <button type="button" className={"btn btn-in-group"+(this.state.whatIsChecked===2?" button-group-chosen":"")}  id="radio-forever"
                checked={this.state.whatIsChecked===2} onClick={this.radioClick}>חזרה לנצח</button>
    }*/
  }

  render() {
    return (
        <div>
            <div className="btn-group" role="group" aria-label="Basic example">
              <button type="button" className={"btn btn-in-group"+(this.state.whatIsChecked===1?" button-group-chosen":"")} id="radio-year"
                checked={this.state.whatIsChecked===1} onClick={this.radioClick}>חזרה</button>
              <button type="button" className={"btn btn-in-group"+(this.state.whatIsChecked===0?" button-group-chosen":"")} id="radio-none"
                checked={this.state.whatIsChecked===0} onClick={this.radioClick}>ללא חזרה</button>
            </div>
            { <div className={"flex-row"+(this.state.whatIsChecked===1?"":" hidden")}>
                <label>מספר שנים לחזרה <b>מהשנה</b></label>
                <input className="form-control input small-input" id="to_year" 
                onChange={this.onInputUpdate.bind(this)} type="number" min="2" value={this.state.to_year}/>
            </div>}
        </div>
    );
  }
}

export default RepeatCheckBox;

/*<div className="flex-row">
                <input type="radio" id="radio-none" name="to_year" 
                checked={this.state.whatIsChecked===0} onChange={this.radioClick}/>
                <label>ללא חזרה</label>
            </div>
            <div className="flex-row">
                <input type="radio" id="radio-year" name="to_year" 
                checked={this.state.whatIsChecked===1} onChange={this.radioClick}/>
                <label>עד שנה</label>
                <input className="form-control small-input" id="to_year" 
                onChange={this.onInputUpdate.bind(this)} value={this.state.to_year}/>
            </div>
            <div className="flex-row">
                <input type="radio" id="radio-forever" name="to_year" 
                checked={this.state.whatIsChecked===2} onChange={this.radioClick}/>
                <label>לנצח</label>
            </div>*/


// WEBPACK FOOTER //
// ./src/components/RepeatCheckBox.js